<script setup>
import { computed, ref } from 'vue'
import { usePlayerService } from '@composables/use-player-service'

const BAR_COUNT = 140
const MIN_BAR_HEIGHT = 0.1

const props = defineProps({
    timeFraction: {
        type: Number,
        default: 0,
    },
    duration: {
        type: Number,
        default: 100,
    },
})

const playerService = usePlayerService()

const bars = ref(
    Array.from({ length: BAR_COUNT }, () => Math.min(1, Math.random() + MIN_BAR_HEIGHT))
)

const invertedFraction = computed(() => 1 - props.timeFraction)

function seekTime({ offsetX, srcElement }) {
    playerService.seekTime((offsetX / srcElement.offsetWidth) * props.duration)
}
</script>

<template>
    <div class="waveform">
        <div
            class="waveform-track"
            @click.stop.prevent="seekTime"
        >
            <div class="waveform-layer">
                <div
                    v-for="(bar, index) in bars"
                    :key="index"
                    class="bar bar-bg"
                    :style="{ transform: `scaleY(${bar})` }"
                />
            </div>

            <div
                class="waveform-layer"
                :style="{ transform: `translateX(${invertedFraction * -100}%)` }"
            >
                <div
                    class="waveform-layer waveform-layer-active"
                    :style="{ transform: `translateX(${invertedFraction * 100}%)` }"
                >
                    <div
                        v-for="(bar, index) in bars"
                        :key="index"
                        class="bar"
                        :style="{ transform: `scaleY(${bar})` }"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.waveform {
    position: relative;
    width: 100%;
    height: 100%;

    &-track {
        @include fill;

        display: flex;
        justify-content: space-between;
        overflow: hidden;
        cursor: pointer;
        background-color: $c-shark;

        @include desktop {
            background: none;
        }
    }

    &-layer {
        @include fill;

        display: flex;
        justify-content: space-between;
        overflow: hidden;
        pointer-events: none;
        backface-visibility: hidden;

        &-active {
            background-color: $c-white;

            @include desktop {
                background: none;
            }
        }
    }
}

.bar {
    display: none;
    width: 2px;
    height: 100%;
    background: $c-highlight;

    @include desktop {
        display: block;
    }
}

.bar-bg {
    background-color: $c-shark;
}
</style>
